export default __webpack_public_path__ + "static/media/sales-info-mobile.4b4ce4a3.png";